import { ChangeResponse, PhxKpiChangeType, PhxKpiChangeTypeEnum } from './phx-overview.types';

export function calculateChange(
  currentValue: number,
  previousValue: number,
  inverted: boolean = false,
  neutralChange: boolean = false,
): ChangeResponse {
  let changeValue = 0;
  let absoluteChangeValue = 0;
  let percentageChangeValue = 0;
  let changeType: PhxKpiChangeType = PhxKpiChangeTypeEnum.NoChange;

  changeValue = parseFloat((currentValue - previousValue).toFixed(10));
  absoluteChangeValue = Math.abs(changeValue);
  if (previousValue === 0) {
    percentageChangeValue = 0;
  } else {
    percentageChangeValue = parseFloat(Math.abs((changeValue / previousValue) * 100).toFixed(2)) || 0;
  }

  if (changeValue > 0) {
    changeType = neutralChange
      ? PhxKpiChangeTypeEnum.Neutral
      : inverted
      ? PhxKpiChangeTypeEnum.Negative
      : PhxKpiChangeTypeEnum.Positive;
  } else if (changeValue < 0) {
    changeType = neutralChange
      ? PhxKpiChangeTypeEnum.Neutral
      : inverted
      ? PhxKpiChangeTypeEnum.Positive
      : PhxKpiChangeTypeEnum.Negative;
  }

  return { changeValue, absoluteChangeValue, percentageChangeValue, changeType };
}